import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { migrateLegacyConnectTokenOnce } from './migrateLegacyConnectToken';

// Adopt any pre-split `connect-token` blob before this store hydrates.
migrateLegacyConnectTokenOnce();

// Our own app session: the API bearer for every request, decoupled from the host IS JWT's lifetime.
// appAccessToken is the bearer; appRefreshToken renews it via /connect/portal-refresh;
// appAccessExpiresAt is the access token's expiry (Unix ms). Used by both portal and desktop.
interface AppSessionState {
    appAccessToken: string | null;
    appRefreshToken: string | null;
    appAccessExpiresAt: number | null;
    setAppSession: (accessToken: string, refreshToken: string, expiresIn: number) => void;
    clearAppSession: () => void;
}

// Persisted so the app session survives a refresh — see the security note in connectCredentialsStore.
export const useAppSessionStore = create<AppSessionState>()(
    persist(
        (set) => ({
            appAccessToken: null,
            appRefreshToken: null,
            appAccessExpiresAt: null,
            setAppSession: (accessToken: string, refreshToken: string, expiresIn: number) =>
                set({
                    appAccessToken: accessToken,
                    appRefreshToken: refreshToken,
                    appAccessExpiresAt: Date.now() + expiresIn * 1000,
                }),
            clearAppSession: () => set({
                appAccessToken: null, appRefreshToken: null, appAccessExpiresAt: null,
            }),
        }),
        { name: 'app-session', version: 0 }
    )
);
